/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnInit } from '@angular/core';

export enum DeviceType {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
}

@Component({
  selector: 'ptl-device-type-chart',
  templateUrl: './device-type-chart.component.html',
  styleUrls: ['../common-analytics-chart-styles.scss', './device-type-chart.component.scss'],
})
export class DeviceTypeChartComponent implements OnInit {
  @Input() deviceCounts: { [key: string]: number };
  @Input() isCompact = false;

  deviceStats: { type: DeviceType; count: number; percentage: number }[] = [];
  totalViews = 0;

  readonly DeviceType = DeviceType;

  ngOnInit(): void {
    this.prepareChartData();
  }

  private prepareChartData(): void {
    if (!this.deviceCounts || Object.keys(this.deviceCounts).length === 0) {
      return;
    }

    this.totalViews = Object.values(this.deviceCounts).reduce((sum, count) => sum + count, 0);

    this.deviceStats = Object.entries(this.deviceCounts)
      .map(([type, count]) => ({
        type: type as DeviceType,
        count,
        percentage: this.totalViews > 0 ? (count / this.totalViews) * 100 : 0,
      }))
      .sort((a, b) => b.count - a.count);
  }
}
